import gql from 'graphql-tag'

export const PreferencesFragment = gql`
  fragment PreferencesFragment on Preferences {
    portions
    regime
    structure
    express
    moment
  }
`
